import { getExternalAccessToken } from './api';

export function isPeopleModel(modelName: string): boolean {
  const key = (modelName || '').trim().toLowerCase();
  return key === 'people' || key === 'person';
}

export function cameraHasPeopleModel(models: string[] | undefined | null): boolean {
  return (models ?? []).some(isPeopleModel);
}

/** wss://…/api/ws/people-count/{camera_id} — тот же хост, что EXTERNAL_API_URL (порт 8443). */
export function buildPeopleCountWebSocketUrl(cameraId: string): string | null {
  const token = getExternalAccessToken();
  const apiBase =
    process.env.REACT_APP_EXTERNAL_WS_URL ||
    process.env.REACT_APP_EXTERNAL_API_URL ||
    'https://camback.test-aivion.ru:8443';

  const wsBase = apiBase.replace(/^https:/i, 'wss:').replace(/^http:/i, 'ws:').replace(/\/$/, '');
  const q = token ? `?token=${encodeURIComponent(token)}` : '';

  return `${wsBase}/api/ws/people-count/${encodeURIComponent(cameraId)}${q}`;
}

export function parsePeopleCountMessage(raw: string): number | null {
  const trimmed = raw.trim();
  if (/^\d+$/.test(trimmed)) {
    return parseInt(trimmed, 10);
  }

  try {
    const data = JSON.parse(trimmed) as unknown;
    if (typeof data === 'number' && Number.isFinite(data)) {
      return Math.max(0, Math.floor(data));
    }
    if (data && typeof data === 'object') {
      const o = data as Record<string, unknown>;
      for (const key of ['count', 'people_count', 'current', 'value', 'total', 'inside', 'occupancy']) {
        const v = o[key];
        if (typeof v === 'number' && Number.isFinite(v)) {
          return Math.max(0, Math.floor(v));
        }
      }
    }
  } catch {
    /* not json */
  }

  return null;
}
